<template>
  <el-footer class="me-area ">
    <div>
      <div class="foot-content">
        <img class="mr-10 mb-10" src="../assets/img/footerLogin.svg" />
        <div>
          <div>
            <span class="foot-text">
              © 2020~{{ currentYear }}
              {{$t('common.footerReserved')}}
            </span>
          </div>
          <div>
            <span class="foot-text">{{$t('common.footerCompany')}}</span>
          </div>
           <div ><router-link class="contact" target="_blank" to="/about/content?code=release_project">{{$t('project.userAgreement')}}</router-link></div >
        </div>
        <div class="contact">
          <div class="foot-text">{{$t('common.businessConsulting')}}</div>
          <p class="foot-text">{{$t('common.Tel')}}：86-20-37616606 {{$t('common.Email')}}：info@infotikx.com</p>
        </div>
      </div>
    </div>
    <div class="record">
      <el-link type="primary" :underline="false" href="https://beian.miit.gov.cn" target="_blank">粤ICP备13073277号</el-link>
      <p>广州市西美信息科技有限公司版权所有</p>
    </div>
  </el-footer>
</template>

<script>
  export default {
    name: "BaseFooter",
    data() {
      return {};
    },
    methods: {},
    mounted() {},
    computed: {
      currentYear() {
        return new Date().getFullYear()
      },
    
    },
  };
</script>

<style>

  .foot-content{
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    box-sizing: border-box;
  }

  .me-area {
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;
    box-shadow: none;

  }

  .el-footer {
    min-width: 100%;
    box-shadow: 0 -2px 3px hsla(0, 0%, 7%, .1), 0 0 0 1px hsla(0, 0%, 7%, .1);
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 800;
    background: #161E2C;
    height: auto !important;
    padding: 16px;
  }

  .me-footer {
    text-align: center;
    line-height: 60px;
    font-size: 18px;
  }

  .me-login-design-color {
    color: #5fb878 !important;
  }

  .foot-text {
    left: 24px;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    margin-top: 2.5px;
    margin-left: 18px;
  }

  .contact {
    color: #dddada;
    margin-left: 9px;
    font-size: 14px;
    color: #2c68ff;
  }

  .record {
    display: flex;
    justify-content: center;
    gap: 10px;
    color: #ffffff;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/BaseFooter.vue